import {
    Flex,
    Input,
    InputGroup,
    InputLeftElement,
    Button,
} from '@chakra-ui/react';
import { SearchIcon } from '@chakra-ui/icons';

const AddUserLicenceTreeToolbar = ({
    onSelectAll,
    onDeselectAll,
    allSelected,
    noneSelected,
    search,
    onSearchChange,
    darkMode,
    borderColor,
    isDisabled = false,
}) => (
    <Flex justify="space-between" align="center" mb={2} gap={3} flexWrap="wrap">
        <Flex gap={2}>
            <Button
                size="sm"
                colorScheme="gray"
                variant={noneSelected ? 'solid' : 'outline'}
                bg={noneSelected ? 'gray.600' : undefined}
                color={noneSelected ? 'white' : undefined}
                _hover={{ bg: noneSelected ? 'gray.700' : undefined }}
                onClick={onDeselectAll}
                isDisabled={isDisabled}>
                Deselect All
            </Button>
            <Button
                size="sm"
                colorScheme="messenger"
                variant={allSelected ? 'solid' : 'outline'}
                onClick={onSelectAll}
                isDisabled={isDisabled}>
                Select All
            </Button>
        </Flex>
        <InputGroup maxW="240px" size="sm">
            <InputLeftElement pointerEvents="none">
                <SearchIcon color="gray.400" />
            </InputLeftElement>
            <Input
                placeholder="Search license..."
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') e.preventDefault();
                }}
                bg={darkMode ? 'dark.bgDark' : undefined}
                color={darkMode ? 'dark.textDark' : undefined}
                borderColor={borderColor}
            />
        </InputGroup>
    </Flex>
);

export default AddUserLicenceTreeToolbar;
